/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react'
import {
    Card,
    Stack,
    Paper,
    Avatar,
    Button,
    Container,
    Typography,
    IconButton,
    TablePagination,
    ListItemIcon,
    Box,
    TextField,
    Tooltip,
    InputAdornment,
    Grid
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import moment from 'moment';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Label from '../../components/label/Label';
import { sentenceCase } from 'change-case';
import Pagination from '@mui/material/Pagination';
import { Navigate, useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { OrdersStatus, NumberFormatter } from '../../utils/helper';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
// redux api 
import { useDeliverOrdersApiMutation } from '../../redux/services/delivery/delivery';

const OrderCard = ({ order, cardNumber, OrdersStatus, }) => {
    const { address, landmark, status, final_amount, updated, created, order_no } = order;
    const createdDate = new Date(created);
    const formattedCreated = createdDate.toLocaleString();

    const updatedDate = new Date(updated);
    const formattedUpdated = updatedDate.toLocaleString();
    return (
        <Card sx={{ display: 'flex', borderLeft: '4px solid green' }}>
            <CardContent sx={{ background: '  #d9e8d9', textAlign: 'center', padding: '14px' }}>
                <Typography variant="h4" color="darkslategray" mt={10}>{cardNumber}</Typography>
            </CardContent>

            <Grid container spacing={2}>
                <Grid item xs={7}>
                    <CardContent>

                        <Box >
                            <Stack direction="row" spacing={3}  >

                                <Stack direction="row" spacing={2}>
                                    <Typography variant="body1" color="gray">Order No:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray">{order_no}</Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="body1" color="gray">created:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray">{formattedCreated} </Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="body1" color="gray">updated:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray"> {formattedUpdated}</Typography>
                                </Stack>

                            </Stack>
                        </Box>
                        <Grid container spacing={2} mt={2}>
                            <Grid item xs={2}>
                                <Typography variant="body1" color="gray">Address:</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray">{address}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} >
                            <Grid item xs={2}>

                                <Typography variant="body1" color="gray">Landmark:</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray">{landmark}</Typography>
                            </Grid>
                        </Grid>


                        {/* <Divider /> */}
                        <hr />
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={2}>
                                <Typography variant="body1" color="gray"> Amount:</Typography>

                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray"><NumberFormatter number={final_amount} /></Typography>

                            </Grid>
                        </Grid>
                    </CardContent>
                </Grid>
                <Grid item xs={5}>
                    <Box sx={{ display: 'flex', justifyContent: "end", padding: "25px" }}>
                        <Stack direction="row" spacing={2} >
                            <Typography variant="body1" color="gray">Status:</Typography>
                            <Box>
                                <ListItemIcon >
                                    {OrdersStatus(status)}
                                </ListItemIcon>
                            </Box>
                        </Stack>
                    </Box>
                </Grid>
            </Grid>

        </Card >
    );
};








const DeliveryOrders = () => {
    const [getDeliveryOrders, deliveryload] = useDeliverOrdersApiMutation()
    const [deliveryOrdersData, setdeliveryrOrdersData] = useState([])
    const [loadOrders, setLoadOrders] = useState(false)
    const [totalPage, setTotalPage] = useState(0)
    const [currentPage, setCurrentPaeg] = useState(1)
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const { id } = useParams()
    console.log("userId", id)
    console.log("UserOrderList", deliveryOrdersData)
    const handleDateChange = (newDates) => {
        setStartDate(newDates[0]);
        setEndDate(newDates[1]);
    };

    const userOrdersList = async (from, to) => {
        const body = {
            id: id,
            page: currentPage,
            date_from: from,
            date_to: to
        }
        const result = await getDeliveryOrders(body)
        setdeliveryrOrdersData(result?.data)
        setLoadOrders(true)
    }
    const navigate = useNavigate();


    useEffect(() => {
        userOrdersList(startDate, endDate)
        setTotalPage(deliveryOrdersData.total)
        setCurrentPaeg(deliveryOrdersData.current)

    }, [loadOrders])
    const handlePageChange = (event, newPage) => {
        setCurrentPaeg(newPage);
    };



    return (
        <>
            <Container maxWidth="xl" >
                <Box mb={5} mt={2}>
                    <Card sx={{ padding: "15px", }}>
                        <Stack direction="row" justifyContent="space-between">

                            <Stack direction="row" >
                                <Button onClick={() => navigate("/dashboard/deliver")}>
                                    <ArrowBackIcon style={{ color: "blue" }} />
                                </Button>
                                <Typography variant='h4' sx={{ marginTop: "10px" }}>Delivery Orders</Typography>
                            </Stack>
                            <Box sx={{ display: "flex", justifyContent: "end" }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs} >
                                    <div>
                                        <DateRangePicker

                                            format="MM/DD/YYYY"
                                            value={[startDate, endDate]}
                                            onChange={(dates) => {
                                                if (dates && dates.length === 2) {
                                                    handleDateChange(dates);
                                                } else {
                                                    handleDateChange([null, null]);
                                                }
                                            }}
                                        />
                                    </div>
                                </LocalizationProvider>
                                <Box ml={2} mt={1}>
                                    <Button variant="contained" component={RouterLink} to={`/delivery-info/${id}`}>Details</Button>
                                </Box>
                            </Box>
                        </Stack>
                    </Card>
                    {deliveryload.isLoading ? <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}><CircularProgress /></Box> : (

                        <Box sx={{ padding: "10px", marginTop: "20px" }} >


                            {
                                deliveryOrdersData?.list?.map((item, index) => (
                                    <Box key={item.id} mt={2}>
                                        <OrderCard order={item} cardNumber={index + 1} OrdersStatus={OrdersStatus} />
                                    </Box>
                                ))
                            }
                            <Box mt={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Pagination
                                    count={totalPage}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    className="pagination-root" />
                            </Box>
                        </Box>
                    )}
                </Box>
            </Container >
        </>
    )
}

export default DeliveryOrders
